
import React from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import CookieConsent from "./components/CookieConsent";
import CookiesPolicy from "./pages/CookiesPolicy";
import PackageDetail from "./pages/PackageDetail";
import PackagesOverview from "./pages/PackagesOverview";
import WhySwitch from "./pages/WhySwitch";
import Resources from "./pages/Resources";
import About from "./pages/About";
import Alternatives from "./pages/Alternatives";
import FAQ from "./pages/FAQ";
import Glossary from "./pages/Glossary";
import Press from "./pages/Press";
import Course from "./pages/Course";
import Legal from "./pages/Legal";

const queryClient = new QueryClient();

const App = () => {
  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <HelmetProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/paket" element={<PackagesOverview />} />
                <Route path="/paket/:packageId" element={<PackageDetail />} />
                <Route path="/varfor" element={<WhySwitch />} />
                <Route path="/resurser" element={<Resources />} />
                <Route path="/om" element={<About />} />
                <Route path="/alternativ" element={<Alternatives />} />
                <Route path="/fragor" element={<FAQ />} />
                <Route path="/ordlista" element={<Glossary />} />
                <Route path="/press" element={<Press />} />
                <Route path="/kurs" element={<Course />} />
                <Route path="/guider" element={<Index />} />
                <Route path="/sekretess" element={<Index />} />
                <Route path="/villkor" element={<Index />} />
                <Route path="/cookies" element={<CookiesPolicy />} />
                <Route path="/juridik" element={<Legal />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
            <CookieConsent />
          </HelmetProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </React.StrictMode>
  );
};

export default App;
